import React from 'react';
import Button from '../common/Button';

const AddToDeckButton = props => {
  const inDeck = Boolean(props.isInDeck);

  return (
    <Button
      className="w-full"
      iconClass={`fas ${inDeck ? 'fa-check' : 'fa-plus'}`}
      onClick={() => props.onAdd()}
      disabled={inDeck}>
      {inDeck ? 'En el mazo' : 'Agregar al mazo'}
    </Button>
  );
};

export default AddToDeckButton;
